import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.625 11C9.625 10.5168 10.0168 10.125 10.5 10.125H12C12.4832 10.125 12.875 10.5168 12.875 11V15.625H14.5C14.9832 15.625 15.375 16.0168 15.375 16.5C15.375 16.9832 14.9832 17.375 14.5 17.375H12H9.5C9.01675 17.375 8.625 16.9832 8.625 16.5C8.625 16.0168 9.01675 15.625 9.5 15.625H11.125V11.875H10.5C10.0168 11.875 9.625 11.4832 9.625 11ZM12 8.5C12.6904 8.5 13.25 7.94036 13.25 7.25C13.25 6.55964 12.6904 6 12 6C11.3096 6 10.75 6.55964 10.75 7.25C10.75 7.94036 11.3096 8.5 12 8.5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
